const commonFr = {
    "restaurant": "Restaurant",
    "restaurant_not_found": "Le restaurant n'est pas disponible.",
    "table_not_available": "Il n'est pas possible de passer commande à cette table.",
    "note": "Note",
    "order": "Commande",
    "internal_error": "La requête a échoué. Le serveur a répondu par l'erreur suivante :",
    "no_results": "Aucun résultat",
    "cancel": "Annuler",
    "save": "Sauvegarder",
    "back": "Dos",
    "search": "Recherche",
    "search_for_file_names": "Rechercher les noms de fichiers",
    "delete": "Supprimer",
    "search_by_restaurant": "Recherche par restaurant",
    "available": "Disponible",
    "unavailable": "Indisponible",
    "name": "Nom",
    "status": "Statut",
    "description": "Description",
    "price": "Prix",
    "add": "Ajouter",
    "phone": "Téléphone",
    "internal_server_error": "Erreur interne du serveur",
    "remove_all": "Effacer tout",
    "settings": "Paramètres",
    "restaurant_name": "Nom du restaurant",
    "reservation_link": "Lien de réservation",
    "reservation_link_tooltip": "Seuls les liens vers le système de réservation Reserours sont autorisés.",
    "add_user": "Ajouter un utilisateur",
    "add_user_title": "Accorder l'accès au restaurant",
    "restaurant_users": "Utilisateurs ayant accès au restaurant",
    "restaurant_description_hu": "Description du restaurant (hongrois)",
    "restaurant_description_en": "Description du restaurant (anglais)",
    "changes_saved": "Les modifications ont été enregistrées avec succès",
    "user_added_to_restaurant": "L'utilisateur a obtenu l'accès au restaurant",
    "user_add_to_restaurant_tip": "L'utilisateur dont l'adresse électronique a été fournie aura accès au restaurant sélectionné. S'il ne possède pas encore de compte, il y aura accès automatiquement après son inscription.",
    "sign_up_here": "Vous pouvez créer un compte ici",
    "role_already_exists": "L'utilisateur associé à cette adresse e-mail a déjà accès au restaurant.",
    "error": "Erreur",
    "header_image": "Image d'en-tête",
    "upload_image": "Télécharger une image",
    "image_not_set": "Image non définie",
    "validation": {
        "required": "Ce champ est obligatoire",
        "optional": "Ce champ est facultatif."
    },
    "hungary": "Hongrie",
    "date": "Date",
    "close": "Fermer",
    "continue": "Continuer",
    "select_image": "Sélectionner une image",
    "grant": "Accorder",
    "restaurant_settings": "Cadre du restaurant",
    "create_restaurant": "Créer un restaurant",
    "restaurant_created": "Restaurant créé avec succès",
    "restaurant_created_text": "Votre restaurant a été créé avec succès. Vous pouvez maintenant ajouter des plats à votre menu et gérer les paramètres de votre restaurant.",
    "continue_to_menu": "Poursuivre la modification du menu",
    "languages": {
        "hu": "hongrois",
        "en": "Anglais",
        "de": "Allemand",
        "fr": "Français",
        "sk": "slovaque",
        "cz": "tchèque",
        "pl": "polonais",
        "si": "slovène",
        "hr": "croate",
        "ro": "roumain"
    },
    "no_file_selected": "Aucun fichier sélectionné",
    "max_file_size": "Taille maximale du fichier :",
    "language": "Langue",
    "google_analytics": "Google Analytics",
    "facebook_pixel": "Pixel Facebook",
    "analytic_integration_premium_feature": "L'intégration analytique fait partie du forfait PRO",
    "refresh": "Rafraîchir",
    "address": "Adresse",
    "city": "Ville",
    "postal_code": "Code Postal",
    "timezone": "Fuseau horaire",
    "country": "Pays",
    "currency": "Devise",
    "currency_tooltip": "Ceci est uniquement nécessaire pour les paramètres de votre profil ; notre système n'effectuera aucune transaction financière en votre nom.",
    "or": "ou"
};

export default commonFr;
